import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './i18n';

// --- Google Translate React Crash Fix ---
// This prevents the "NotFoundError: Failed to execute 'removeChild' on 'Node'" error
// that happens when Google Translate modifies text nodes that React manages.
if (typeof Node === 'function' && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child.parentNode !== this) {
      if (console) {
        console.warn('Google Translate Crash Fix: Cannot remove child from a different parent', child, this);
      }
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      if (console) {
        console.warn('Google Translate Crash Fix: Cannot insert before a reference node from a different parent', referenceNode, this);
      }
      return originalInsertBefore.apply(this, [newNode, null]);
    }
    return originalInsertBefore.apply(this, arguments);
  };
}
// ----------------------------------------

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
